import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'

import Header from 'app/BCKSPage/components/Header'
import AndroidHandler from 'utils/androidHandler'
import { PDFViewer } from 'components/PDFViewer'

const PATH_BACK = '/bcks/invitation/final'

const BCKSPDFPreview = ({ url, title }) => {
  const androidHandler = AndroidHandler()
  const router = useRouter()

  const handleBackClick = () => {
    if (androidHandler.enabled)
      historyUtils.backToApp(() => router.replace(PATH_BACK))
    else router.replace(PATH_BACK)
  }
  return (
    <div className="min-h-screen max-w-xl mx-auto bg-surface-subdued">
      <Header title={title} onBackClick={handleBackClick} />
      <PDFViewer url={url} />
    </div>
  )
}

export default BCKSPDFPreview
